import { Capacitor } from "@capacitor/core";

/**
 * Platform detection for the Routify native wrapper.
 *
 * These helpers distinguish the Capacitor webview from the browser PWA.
 * They are safe to call during hydration because Capacitor.getPlatform() only
 * inspects the user-agent / bridge state and does not touch browser-only globals.
 */

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function getNativePlatform(): "ios" | "android" | "web" {
  const platform = Capacitor.getPlatform();
  if (platform === "ios") return "ios";
  if (platform === "android") return "android";
  return "web";
}

export function isIOS(): boolean {
  return Capacitor.getPlatform() === "ios";
}

export function isAndroid(): boolean {
  return Capacitor.getPlatform() === "android";
}
